<template>
    <div id="organizations-view" class="view">
        <settings-menu></settings-menu>

        <organizations-table></organizations-table>

    </div>
</template>

<script>
import SettingsMenu from '@/components/layout/SettingsMenu'
import OrganizationsTable from '@/views/Organizations/components/OrganizationsTable'

const body = document.body

export default {
    name: 'OrganizationsList',
    mounted () {
        body.classList.add('organizations-view')
    },
    beforeDestroy () {
        body.classList.remove('organizations-view')
    },
    components: {
        OrganizationsTable,
        SettingsMenu
    }
}
</script>

<style lang="scss">
.organizations-view {
    background-color: $white;

    .buttons {
        display: flex;

        .small-button {
            background: $secondary;
            color: $white;
            white-space: nowrap;
            height: auto;
            padding: 3px 10px;
            margin: 11px 4px;
            font-size: 11px;
            display: flex;
            align-items: center;
            border-radius: 7px;
        }
    }
}
</style>
